import BigNumber from "bignumber.js";
import { t } from "modules/utils/intl";

export const getShortNumber = (number: BigNumber): string => {
  return t("formats.number-compact", { value: number }).toLowerCase();
};
